<template>
    <div>
        <div v-if="showWO" class="container mt-4 mb-2">
            <div class="row d-flex justify-content-center justify-content-md-start gap-1 gap-md-3">
                <div id="pedido-tour-desktop"  class="col-5 col-md-4 col-lg-2 text-center rounded bg-darkblue btn-insitu py-3 px-1">
                    <a id="boton-hacer-pedido" title="hacer pedido" class=" text-decoration-none text-white text-title-bat cursor-pointer" @click="trackingMakeAnOrder('makeAnOrder')">
                        <img class="img-menu-fixed" src="/img/icons/cart_new_look_white.svg" alt="Hacer pedido">
                        Hacer pedido
                    </a>
                </div>
                <div id="facturas-vue" class="col-5 col-md-4 col-lg-2 text-center  bg-lightBlue rounded btn-insitu py-3 px-1">
                    <a id="boton-mis-facturas" title="mis facturas" class=" text-decoration-none text-white  text-title-bat cursor-pointer" @click="trackingMakeAnOrder('myInvoices')">
                        <img class="img-menu-fixed" src="/img/icons/mis-facturas-white.svg" alt="Mis facturas">
                        Mis facturas
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from './../../app';

    export default {
        data() {
            return {
               showWO: false
            };
        },
        mounted() {
            this.getCheckSelectPDV();
            EventBus.$on('change-select-pdv', function (select_pdv) {
                this.getCheckSelectPDV()
            }.bind(this))
        },
        methods: {
            trackingMakeAnOrder(name){
                let log = 'Entered to place an order';

                if(name === 'myInvoices'){
                    log = 'Entered to my invoices';
                }
                axios.post('/trackingLog', {
                    logName: name,
                    log: log,
                }).then(
                    ({data}) => {
                        if(name !== 'makeAnOrder'){
                            window.location.href = "/orders/history";
                        }else{
                            window.location.href = "/pedidos";
                        }

                    })
            },

            getCheckSelectPDV() {
                this.loading = 1;
                axios.get(`/check-selected-pdv-token-wo`)
                    .then(({ data }) => {
                        this.showWO = data.token.success
                    })
                    .catch(error => {
                        console.error("Error al obtener los PDVs activos", error);
                    })
                    .finally(() => {
                        this.loading = 0;
                    });
            },
        }
    }
</script>

